export default {
  "content": "<path d=\"M10.1 4.004A1 1 0 0111 5v6h9.086l-2.792-2.793 1.413-1.415 4.5 4.5a1.001 1.001 0 010 1.415l-4.5 4.5-1.413-1.415L20.086 13h-9.085v6a1 1 0 01-1 1H0v-2h9V6H0V4h10l.098.005z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};